export const GET_STORE_SUBSCRIPTION_RQ_KEY = "GET_STORE_SUBSCRIPTION";
export const GET_STORE_SUBSCRIPTION_SUBSCRIBERS_RQ_KEY =
  "GET_STORE_SUBSCRIPTION_SUBSCRIBERS";
export const GET_STORE_SUBSCRIPTION_SUBSCRIBER_RQ_KEY =
  "GET_STORE_SUBSCRIPTION_SUBSCRIBER";
export const GET_SUBSCRIPTION_SALES_INSIGHTS_RQ_KEY = "GET_SUBSCRIPTION_SALES_INSIGHTS";

/** For useIsMutating — subscription cover image upload/delete from any screen. */
export const SUBSCRIPTION_COVER_IMAGE_UPLOAD_MUTATION_KEY =
  "SUBSCRIPTION_COVER_IMAGE_UPLOAD";
export const SUBSCRIPTION_COVER_IMAGE_DELETE_MUTATION_KEY =
  "SUBSCRIPTION_COVER_IMAGE_DELETE";

export const LIST_STORE_SUBSCRIPTIONS_RQ_KEY = "LIST_STORE_SUBSCRIPTIONS";

export const SEARCH_STORE_SUBSCRIPTIONS_RQ_KEY = "SEARCH_STORE_SUBSCRIPTIONS";
